import client from '../base-api';

const serviceURL = '/enums';

const enumService = {
  getEnums(): Promise<any> {
    return client.get(serviceURL);
  },
};

export default enumService;
